import React from "react";
import IntlMessages from "@util/IntlMessages";
import ButtonSettings from "./ButtonSettings";
import ButtonImageSettings from "./ButtonImageSettings";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";
import ButtonEndModalSettings from "./ButtonEndModalSettings";

const ButtonModal = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.widgetSettings" />} key="2">
            <ButtonSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.imageSettings" />} key="3">
            <ButtonImageSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.endModalSettings" />} key="4">
            <ButtonEndModalSettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default ButtonModal;
